import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { TrasladosdeFondos } from './modalTraslados';
import ValidarUsuario from '../comun/modalValidarUsuario';

const TablaTraslados = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [tipomov, setTipomov] = useState(0);
  const [presupuesto, setPresupuesto] = useState();
  const [movimientos, setMovimientos] = useState();
  const [movimientosd, setMovimientosd] = useState();
  const [organ, setOrga] = useState();
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [idTransfe, setIdtransfe] = useState(0);
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.idtransferencia.includes(target.value)
              || x.fechamov.toLowerCase().includes(target.value.toLowerCase())
              || x.observaciones.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/registrosdtraslados?idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        setRecords(response.data);
        txtBuscador.current.focus();
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarPresupuesto = (id) => {
    let campos = '*';
    let nomtab = 'transferencia';
    let nomid = 'idtransferencia';
    let nomid2 = 'idefiscal';

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${idefiscal}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data.length > 0) {
          setPresupuesto(response.data[0]);
          seleccionarOrganismo(response.data[0].idtransferencia, response.data[0].idorganismo);
        } else {
          setPresupuesto([]);
          seleccionarOrganismo(response.data[0].idtransferencia, response.data[0].idorganismo);
        }

      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const seleccionarOrganismo = (idtrans, idorg) => {

    let campos = "*"
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorg}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idproveedor > 0) {
          setOrga(response.data);
          MovimientosSeleccionarsOrigen(idtrans);
        } else {
          setOrga();
          MovimientosSeleccionarsOrigen(idtrans);
        }

      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const MovimientosSeleccionarsOrigen = (id) => {

    setActivate(true);
    let tipo = 2;

    let endpoint = `${op.conexion}/api/presupuesto/datostablapresupuestoorigen?tipo=${tipo}&id=${id}&idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.length > 0) {
          setMovimientos(response.data);
          MovimientosSeleccionarsDestino(id);
        } else {
          setMovimientos([]);
          MovimientosSeleccionarsDestino(id);
        }

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const MovimientosSeleccionarsDestino = (id) => {

    setActivate(true);
    let tipo = 3;

    let endpoint = `${op.conexion}/api/presupuesto/datostablapresupuestoorigen?tipo=${tipo}&id=${id}&idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.length > 0) {
          setMovimientosd(response.data);
          setMostrar2(true);
        } else {
          setMovimientosd([]);
          setMostrar2(true);
        }

      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarCtaPresupuestaria = (op, data) => (e) => {

    if (op === 4) {
      setOperacion(4);
      SeleccionarPresupuesto(data.idtransferencia);
    } else if (op === 1) {
      setOperacion(op);
      setTipomov(9);
      setMostrar2(true)
    } else if (op === 2) {

      if (data.reversado > 0) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'El Traslado ya fue Reversado', icono: 'informacion' });
      } else {
        //setMostrarUsuario(true);
        setOperacion(op);
        //setIdtransfe(data.idtransferencia);
        setTipomov(9);
        SeleccionarPresupuesto(data.idtransferencia); 
      }

    } else if (op === 3) {
      
        setMostrarUsuario(true);
        setOperacion(op);
        setIdtransfe(data.idtransferencia);
        /* setTipomov(9);
        SeleccionarPresupuesto(data.idtransferencia); */
      

    } else if (op === 5) {

      if (data.reversado > 0) {
        setMostrarUsuario(true);
        setOperacion(op);
        setIdtransfe(data.idtransferencia);
        /* setTipomov(9);
        SeleccionarPresupuesto(data.idtransferencia); */
      } else {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'Debe Reversar el Traslado para poder Eliminar el Registro', icono: 'informacion' });
      }

    }

  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setIdtransfe(0);
    setMostrar2(false);
  }

  const cerrar = () => {
    props.menu()
  }

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    setTipomov(9);
    SeleccionarPresupuesto(idTransfe);
    
  };

  return (
    <section className='modal-azulGradiant mx-auto col-9'>
      <header className='header-azulGradiant'>
        <h3 >
          Traslados

        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input  col-3 form-control form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button onClick={gestionarCtaPresupuestaria(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>
      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.idtransferencia}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fechamov).format('DD-MM-YYYY')}</td>
                  <td className='align-middle' style={{ textAlign: "left", alignItems: 'center', width: '350px' }}>{item.observaciones}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '80px' }}>
                    <button onClick={gestionarCtaPresupuestaria(4, item)} title='Consultar' className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i></button>
                    <button onClick={gestionarCtaPresupuestaria(3, item)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fas fa-edit"></i></button>
                    {item.reversado === 0 ? <button onClick={gestionarCtaPresupuestaria(2, item)} title='Reversar' className="btn btn-sm mx-1 btn-success rounded-pill"><i className="fas fa-sync-alt"></i></button>
                      : <button onClick={gestionarCtaPresupuestaria(5, item)} title='Eliminar' className="btn btn-sm mx-1 btn-danger rounded-pill"><i className="fas fa-trash-alt"></i></button>
                    }</td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <TrasladosdeFondos
        show={mostrar2}
        operacion={operacion}
        presu={presupuesto}
        movi={movimientos}
        movid={movimientosd}
        tipomov={tipomov}
        org={organ}
        titulo={operacion === 4 ? 'Consulta Traslado' : operacion === 2 ? 'Reversar Traslado' : operacion === 1 ? 'Traslado' : 'Eliminar Traslado'}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />

      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setIdtransfe(0);
          setMostrarUsuario(false);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={2}
      />

      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaTraslados;